<template>
  <div class="productListHorizon" v-if="!nodata">
    <div class="title">{{ title }}</div>
    <div class="productList">
      <div
        class="card"
        v-for="(item, index) in data"
        :key="index"
        @click="showProduct(item)"
      >
        <div :class="[productCompanyGroupName(item), 'imgWrap']">
          <div v-if="item.addons" class="strip">
            <span>โปรโมชั่น</span>
          </div>
          <img
            v-if="item.productPhotos"
            :src="
              item.productPhotos.length > 0
                ? item.productPhotos[0].url
                : $placeholderImg
            "
          />
          <img v-else :src="$placeholderImg" />
        </div>
        <div class="detailWrap">
          <div>{{ item.name }}</div>
          <!-- <div>{{ item.description }}</div> -->
          <ProductStatus :product="item" />
          <div class="priceWrap">
            <span class="price">
              <span v-if="calStep(item)"
                >{{ calStep(item).min.toLocaleString() }} ~
                {{ calStep(item).max.toLocaleString() }}</span
              >
              <span v-else>{{ item.salePrice.toLocaleString() }}</span>
            </span>
            <span class="unitPrice">บาท</span>
            <span v-if="item.price !== item.salePrice" class="fromPrice"
              >{{ item.price }} <span class="">บาท</span></span
            >
            <span class="unit"> / {{ item.unit }}</span>
          </div>
        </div>
        <div class="actionContain">
          <div class="actionWrap">
            <div class="editBtn">แก้ไข</div>
          </div>
        </div>
      </div>
    </div>
    <ProductListHorizonLoader v-if="fetching" />
    <DefaultDisplayStage :error="error" :nodata="nodata" />
  </div>
</template>

<script>
import DefaultDisplayStage from "@/components/DefaultDisplayStage";
import ProductListHorizonLoader from "@/components/loader/ProductListHorizonLoader";
import { GET } from "@/utils/http";
import { call } from "vuex-pathify";
import { calStep } from "@/utils/product";
import ProductStatus from "@/components/ProductStatus";

export default {
  props: { title: String, catId: Number },
  components: {
    DefaultDisplayStage,
    ProductListHorizonLoader,
    ProductStatus,
  },
  data() {
    return {
      products: [],
      fetching: false,
      error: false,
    };
  },
  watch: {},
  computed: {
    nodata() {
      return !this.fetching && this.data.length <= 0 && !this.error;
    },
    data() {
      return this.products.filter((e) => e.deleted !== true);
    },
  },
  methods: {
    calStep: calStep,
    ...call("showProduct/*"),
    async getThaibevBands() {
      try {
        this.fetching = true;
        const { status, body } = await GET(
          "/api/brands?page=1&limit=100&query=&companyGroup=thaibev&forImport=false&all=true"
        );
        console.log("getThaibevBands status body", status, body);
        if (status !== 200) {
          throw "not ok";
        }
        this.categories = body.data;
        // this.processData()
      } catch (err) {
        this.error = true;
      } finally {
        this.fetching = false;
      }
    },
    async getCategoryProduct() {
      try {
        this.fetching = true;
        const { status, body } = await GET(
          `/api/shops/${this.$myShop.id}/products?page=1&limit=100&query=&brandIds=${this.catId}&forImport=false&all=true`
        );

        if (status !== 200) {
          throw "not ok";
        }

        this.products = body.data || [];
      } catch (err) {
        this.error = true;
      } finally {
        this.fetching = false;
      }
    },
  },
  mounted() {
    this.getCategoryProduct();
    console.log("mounted cat", this.title, this.catId);
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/productCardListHorizon.scss";
</style>